import { SelectOptions } from '@/types/form';

/**
 * 给定val值和字典 返回字典中的label
 */
export function getLabelFromDict(val: number | string, dict: SelectOptions<number | string>[]) {
  const target = dict.find((item) => `${item.value}` === `${val}`);
  if (target) {
    return target.label;
  }
}

export function fontSizeWin() {
  const docEl = document.documentElement;

  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  const recalc = function () {
    const clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    if (clientWidth <= 1180 && clientWidth >= 767) {
      // PC端字体
      docEl.style.fontSize = 37.5 * (clientWidth / 1180) + 'px';
    } else if (clientWidth < 767) {
      // 移动端字体
      docEl.style.fontSize = 37.5 * (clientWidth / 375) + 'px';
    } else {
      // 字体最大值
      docEl.style.fontSize = 37.5 + 'px';
    }
  };

  if (!document.addEventListener) return;
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/**
 * @desc 返回对象是否某个类型
 * @param {Object} obj 对象
 * @param {String} type 类型
 * @returns {Boolean}
 */
export function cheakTypeObject(obj: Record<string, any>, type: string): boolean {
  return Object.prototype.toString.call(obj) === `[object ${type}]`;
}

export function getGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
